import React, { useState } from 'react';
import { FONT_FAMILY, COLORS } from '../theme';

interface LegendProps {
    COLORS: any;
    FONT_FAMILY: string;
}

export const Legend: React.FC<LegendProps> = ({ COLORS, FONT_FAMILY }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div style={{
            position: 'absolute',
            top: 16,
            right: 16,
            zIndex: 500,
            fontFamily: FONT_FAMILY
        }}>
            {/* Legend Header - always visible */}
            <div
                style={{
                    background: 'rgba(30, 30, 40, 0.85)',
                    color: '#fff',
                    padding: '6px 10px',
                    borderRadius: '6px 6px 0 0',
                    fontSize: 12,
                    fontWeight: 600,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    boxShadow: COLORS.boxShadow,
                    userSelect: 'none',
                    minWidth: '70px',
                    justifyContent: 'center'
                }}
                onClick={() => setIsExpanded(!isExpanded)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        setIsExpanded(!isExpanded);
                    }
                }}
                tabIndex={0}
                role="button"
                aria-expanded={isExpanded}
                aria-label="Toggle legend"
            >
                <span>Legend</span>
                <svg
                    width="10"
                    height="10"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{
                        transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.2s ease'
                    }}
                >
                    <polyline points="6,9 12,15 18,9" />
                </svg>
            </div>

            {/* Legend Content - expandable, more compact */}
            {isExpanded && (
                <div style={{
                    background: 'rgba(30, 30, 40, 0.95)',
                    color: '#fff',
                    padding: '8px 0px',
                    borderRadius: '0 0 6px 6px',
                    fontSize: 12,
                    fontWeight: 400,
                    boxShadow: COLORS.boxShadow,
                    minWidth: '180px',
                    textAlign: 'center'
                }}>
                    <img
                        src="/legend.png"
                        alt="Magnetic field strength legend"
                        style={{
                            width: '100%',
                            height: 'auto',
                            maxWidth: '80px',
                            marginBottom: '4px'
                        }}
                    />
                    <div style={{
                        fontSize: 11,
                        color: 'rgba(255, 255, 255, 0.8)',
                        fontWeight: 500,
                        padding: '0 8px'
                    }}>
                        Units: Gauss
                    </div>
                </div>
            )}
        </div>
    );
}; 